module.exports = __webpack_public_path__ + "media/mypage/images/arrow_left-8b3fe0abf8e4c9fd66166fbb4f85c290.png";